import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { Article } from './Article';
import { Event } from './Event';

export class HomePromotion {
  @Type(() => Event)
  events?: Event[];

  @Type(() => Article)
  articles?: Article[];

  constructor(events?: Event[], articles?: Article[]) {
    this.events = events;
    this.articles = articles;
  }

  static fromJson(json: Record<string, any>): HomePromotion {
    return plainToInstance(HomePromotion, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
